module.exports = __webpack_public_path__ + "img/man.e4c2ea96.png";